import { Popover } from "@progress/kendo-react-tooltip";
import { useRef, useState } from "react";
import { useGetActivitesQuery, useGetCategoriesQuery, useGetDepartementsQuery, useGetDivisionsQuery, useGetFournisseursQuery } from "../../redux/api/cache";
import "./productinfo.css";
import LoaderContainer from "../container/LoaderContainer";

interface ProductInfoProps {
    item: any;
}

export default function ProductInfo(props: ProductInfoProps) {
    const item = props.item;
    const [showPopover, setShowPopover] = useState<boolean>(false);
    const { data: fournisseurs = [], isLoading: isFournisseursLoading, isFetching: isFournisseursFetching } = useGetFournisseursQuery(undefined, { skip: !showPopover });
    const { data: divisions = [], isLoading: isDivisionsLoading, isFetching: isDivisionsFetching } = useGetDivisionsQuery(undefined, { skip: !showPopover });
    const { data: departements = [], isLoading: isDepartementsLoading, isFetching: isDepartementsFetching } = useGetDepartementsQuery(item.div_num, { skip: !showPopover });
    const { data: categories = [], isLoading: isCategoriesLoading, isFetching: isCategoriesFetching } = useGetCategoriesQuery({ div: item.div_num, dept: item.dept_cd, four: item.four_cd }, { skip: !showPopover });
    const { data: activites = [], isLoading: isActivitesLoading, isFetching: isActivitesFetching } = useGetActivitesQuery(undefined, { skip: !showPopover });
    const ref = useRef<HTMLElement>(null);

    return <>
        <span ref={ref} className="infos-text" onMouseEnter={() => setShowPopover(true)} onMouseLeave={() => setShowPopover(false)}>
            {`${item.four_cd.toUpperCase()}, Cat. ${item.div_num} > ${item.dept_cd.toUpperCase()} > ${item.cat_cd.toUpperCase()}, Act. ${item.act_cd}`}
        </span>
        <Popover
            show={showPopover}
            anchor={ref.current}
            title="Informations supplémentaires"
            collision={{
                horizontal: "fit",
                vertical: "flip",
            }}
            key={Math.random()}
        >
            {!isFournisseursFetching && !isFournisseursLoading && !isDivisionsFetching && !isDivisionsLoading && !isDepartementsFetching && !isDepartementsLoading && !isCategoriesFetching && !isCategoriesLoading && !isActivitesFetching && !isActivitesLoading && (<div className="popover-wrapper">
                <span className="product-header">Fournisseur:</span>
                <span>{fournisseurs.find(f => f.four_cd.toUpperCase() === item.four_cd.toUpperCase())?.four_nom_aff}</span>
                <span className="product-header">Division:</span>
                <span>{divisions.find(d => d.div_num === item.div_num)?.div_nom_aff}</span>
                <span className="product-header">Département:</span>
                <span>{departements.find(d => d.dept_cd.toUpperCase() === item.dept_cd.toUpperCase())?.dept_nom_aff}</span>
                <span className="product-header">Catégorie</span>
                <span>{categories.find(c => c.cat_cd.toUpperCase() === item.cat_cd.toUpperCase())?.cat_descr_aff}</span>
                <span className="product-header">Activité</span>
                <span>{activites.find(a => a.act_cd === item.act_cd)?.act_aff}</span>
            </div>)}
            {(isFournisseursFetching || isFournisseursLoading || isDivisionsFetching || isDivisionsLoading || isDepartementsFetching || isDepartementsLoading || isCategoriesFetching || isCategoriesLoading || isActivitesFetching || isActivitesLoading) && (<LoaderContainer />)}
        </Popover>
    </>;
}